import React from "react";
import { useIntegrationLogoStyles } from "./styles";

export function IntegrationLogo(props) {
  const classes = useIntegrationLogoStyles();
  let svg;
  switch (props.integrationType) {
    case "aws/Initialize":
      svg = (
        <svg
          width={props.width}
          height={props.height}
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 304 182"
        >
          <g>
            <path
              className={classes.awsTxt}
              d="m86.4 66.4c0 3.7 0.4 6.7 1.1 8.9 0.8 2.2 1.8 4.6 3.2 7.2 0.5 0.8 0.7 1.6 0.7 2.3 0 1-0.6 2-1.9 3l-6.3 4.2c-0.9 0.6-1.8 0.9-2.6 0.9-1 0-2-0.5-3-1.4-1.4-1.5-2.6-3.1-3.6-4.7-1-1.7-2-3.6-3.1-5.9-7.8 9.2-17.6 13.8-29.4 13.8-8.4 0-15.1-2.4-20-7.2s-7.4-11.2-7.4-19.2c0-8.5 3-15.4 9.1-20.6s14.2-7.8 24.5-7.8c3.4 0 6.9 0.3 10.6 0.8s7.5 1.3 11.5 2.2v-7.3c0-7.6-1.6-12.9-4.7-16-3.2-3.1-8.6-4.6-16.3-4.6-3.5 0-7.1 0.4-10.8 1.3s-7.3 2-10.8 3.4c-1.6 0.7-2.8 1.1-3.5 1.3s-1.2 0.3-1.6 0.3c-1.4 0-2.1-1-2.1-3.1v-4.9c0-1.6 0.2-2.8 0.7-3.5s1.4-1.4 2.8-2.1c3.5-1.8 7.7-3.3 12.6-4.5 4.9-1.3 10.1-1.9 15.6-1.9 11.9 0 20.6 2.7 26.2 8.1 5.5 5.4 8.3 13.6 8.3 24.6v32.4zm-40.6 15.2c3.3 0 6.7-0.6 10.3-1.8s6.8-3.4 9.5-6.4c1.6-1.9 2.8-4 3.4-6.4s1-5.3 1-8.7v-4.2c-2.9-0.7-6-1.3-9.2-1.7s-6.3-0.6-9.4-0.6c-6.7 0-11.6 1.3-14.9 4s-4.9 6.5-4.9 11.5c0 4.7 1.2 8.2 3.7 10.6 2.4 2.5 5.9 3.7 10.5 3.7zm80.3 10.8c-1.8 0-3-0.3-3.8-1-0.8-0.6-1.5-2-2.1-3.9l-23.5-77.3c-0.6-2-0.9-3.3-0.9-4 0-1.6 0.8-2.5 2.4-2.5h9.8c1.9 0 3.2 0.3 3.9 1 0.8 0.6 1.4 2 2 3.9l16.8 66.2 15.6-66.2c0.5-2 1.1-3.3 1.9-3.9s2.2-1 4-1h8c1.9 0 3.2 0.3 4 1 0.8 0.6 1.5 2 1.9 3.9l15.8 67 17.3-67c0.6-2 1.3-3.3 2-3.9 0.8-0.6 2.1-1 3.9-1h9.3c1.6 0 2.5 0.8 2.5 2.5 0 0.5-0.1 1-0.2 1.6s-0.3 1.4-0.7 2.5l-24.1 77.3c-0.6 2-1.3 3.3-2.1 3.9s-2.1 1-3.8 1h-8.6c-1.9 0-3.2-0.3-4-1s-1.5-2-1.9-4l-15.5-64.5-15.4 64.4c-0.5 2-1.1 3.3-1.9 4s-2.2 1-4 1h-8.6zm128.5 2.7c-5.2 0-10.4-0.6-15.4-1.8s-8.9-2.5-11.5-4c-1.6-0.9-2.7-1.9-3.1-2.8s-0.6-1.9-0.6-2.8v-5.1c0-2.1 0.8-3.1 2.3-3.1 0.6 0 1.2 0.1 1.8 0.3s1.5 0.6 2.5 1c3.4 1.5 7.1 2.7 11 3.5 4 0.8 7.9 1.2 11.9 1.2 6.3 0 11.2-1.1 14.6-3.3s5.2-5.4 5.2-9.5c0-2.8-0.9-5.1-2.7-7s-5.2-3.6-10.1-5.2l-14.5-4.5c-7.3-2.3-12.7-5.7-16-10.2-3.3-4.4-5-9.3-5-14.5 0-4.2 0.9-7.9 2.7-11.1s4.2-6 7.2-8.2c3-2.3 6.4-4 10.4-5.2s8.2-1.7 12.6-1.7c2.2 0 4.5 0.1 6.7 0.4 2.3 0.3 4.4 0.7 6.5 1.1 2 0.5 3.9 1 5.7 1.6s3.2 1.2 4.2 1.8c1.4 0.8 2.4 1.6 3 2.5 0.6 0.8 0.9 1.9 0.9 3.3v4.7c0 2.1-0.8 3.2-2.3 3.2-0.8 0-2.1-0.4-3.8-1.2-5.7-2.6-12.1-3.9-19.2-3.9-5.7 0-10.2 0.9-13.3 2.8s-4.7 4.8-4.7 8.9c0 2.8 1 5.2 3 7.1s5.7 3.8 11 5.5l14.2 4.5c7.2 2.3 12.4 5.5 15.5 9.6s4.6 8.8 4.6 14c0 4.3-0.9 8.2-2.6 11.6-1.8 3.4-4.2 6.4-7.3 8.8-3.1 2.5-6.8 4.3-11.1 5.6-4.5 1.4-9.2 2.1-14.3 2.1z"
            />
            <path
              className={classes.awsSmile}
              d="m273.5 143.7c-32.9 24.3-80.7 37.2-121.8 37.2-57.6 0-109.5-21.3-148.7-56.7-3.1-2.8-0.3-6.6 3.4-4.4 42.4 24.6 94.7 39.5 148.8 39.5 36.5 0 76.6-7.6 113.5-23.2 5.5-2.5 10.2 3.6 4.8 7.6z"
            />
            <path
              className={classes.awsSmile}
              d="m287.2 128.1c-4.2-5.4-27.8-2.6-38.5-1.3-3.2 0.4-3.7-2.4-0.8-4.5 18.8-13.2 49.7-9.4 53.3-5 3.6 4.5-1 35.4-18.6 50.2-2.7 2.3-5.3 1.1-4.1-1.9 4-9.9 12.9-32.2 8.7-37.5z"
            />
          </g>
        </svg>
      );
      break;
    case "duo/poll":
      svg = (
        <svg
          width={props.width}
          height={props.height}
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 13325.2 4299.3332"
        >
          <g transform="matrix(1.3333333,0,0,-1.3333333,0,4299.3333)">
            <path
              className={classes.duoGreen1}
              d="m1612.2-0.011719h-1612.3v1531.6h3222.5c-42.01-852.97-746.86-1531.6-1610.2-1531.6"
            />
            <path
              className={classes.duoGreen2}
              d="m1612.2 3224.5h-1612.3v-1531.6h3222.5c-42.01 852.96-746.86 1531.6-1610.2 1531.6"
            />
            <path
              className={classes.duoGreen2}
              d="m8383.7 3224.5c-863.38 0-1568.2-678.67-1610.2-1531.6h3220.5c-42.01 852.96-746.86 1531.6-1610.2 1531.6"
            />
            <path
              className={classes.duoGreen1}
              d="m8383.7-0.011719c-863.38 0-1568.2 678.67-1610.2 1531.6h3220.5c-42.01-852.97-746.86-1531.6-1610.2-1531.6"
            />
            <path
              className={classes.duoGreen2}
              d="m3385.7 3224.5v-1612.2c0-863.38 678.67-1568.2 1531.6-1610.2v3222.5h-1531.6"
            />
            <path
              className={classes.duoGreen1}
              d="m6610.2-0.011719h-1531.6v3224.5h1531.6v-3224.5"
            />
          </g>
        </svg>
      );
      break;
    case "o365/Initialize":
      svg = (
        <svg
          width={props.width}
          height={props.height}
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1319.928 213.51855"
        >
          <g>
            <g>
              <rect
                className={classes.m365sq1}
                y=".0019531"
                width="101.46"
                height="101.46"
              />
              <rect
                className={classes.m365sq2}
                x="112.02"
                width="101.46"
                height="101.46"
              />
              <rect
                className={classes.m365sq3}
                y="112.06"
                width="101.46"
                height="101.46"
              />
              <rect
                className={classes.m365sq4}
                x="112.02"
                y="112.06"
                width="101.46"
                height="101.46"
              />
            </g>
            <g className={classes.m365Txt}>
              <path d="m352.97 123.03-5.9951 16.775h-0.34082c-1.0708-3.9307-2.8652-9.5064-5.6753-16.592l-32.08-80.472h-31.364v127.94h20.686v-78.65c0-4.8545-0.1045-10.722-0.3086-17.435-0.10595-3.398-0.49267-6.1191-0.58642-8.1938h0.45459c1.0513 4.8223 2.144 8.4932 2.9326 10.95l38.467 93.329h14.47l38.181-94.171c0.86719-2.1475 1.7842-6.3374 2.6289-10.108h0.4541c-0.5 9.3203-0.92383 17.838-0.98047 22.978v81.301h22.066v-127.94h-30.119z" />
              <rect x="436.75" y="78.993" width="21.568" height="91.687" />
              <path d="m447.76 40.028c-3.5537 0-6.6436 1.2144-9.1885 3.6025-2.5537 2.3999-3.8486 5.4282-3.8486 8.9966 0 3.5098 1.2803 6.4766 3.8057 8.8169 2.5146 2.3315 5.6221 3.5117 9.2314 3.5117 3.6104 0 6.7305-1.1802 9.2734-3.5083 2.5586-2.3438 3.8555-5.3105 3.8555-8.8203 0-3.4458-1.2646-6.437-3.7529-8.897-2.4873-2.457-5.6416-3.7021-9.376-3.7021" />
              <path d="m534.68 78.075c-4.1484-0.85791-8.2002-1.2925-12.053-1.2925-9.8984 0-18.722 2.1196-26.229 6.3062-7.5225 4.1899-13.344 10.174-17.295 17.787-3.9463 7.5938-5.9443 16.457-5.9443 26.346 0 8.665 1.9414 16.61 5.7705 23.62 3.8389 7.0234 9.2666 12.512 16.14 16.321 6.8682 3.7998 14.8 5.731 23.58 5.731 10.249 0 19.003-2.0493 26.016-6.0918l0.28516-0.16553v-19.755l-0.90723 0.65967c-3.1807 2.3159-6.7324 4.1655-10.551 5.4932-3.8145 1.3306-7.29 2.0059-10.334 2.0059-8.4629 0-15.254-2.6489-20.188-7.8716-4.9414-5.2275-7.4473-12.559-7.4473-21.798 0-9.2978 2.6084-16.829 7.7607-22.381 5.1367-5.5405 11.943-8.3506 20.229-8.3506 7.0938 0 13.998 2.4019 20.531 7.1426l0.90723 0.65674v-20.819l-0.29004-0.16553c-2.46-1.3755-5.8164-2.5112-9.9805-3.3765" />
              <path d="m605.74 77.401c-5.417 0-10.268 1.7417-14.424 5.1719-3.6465 3.0112-6.2793 7.1416-8.2969 12.297h-0.22851v-15.877h-21.566v91.687h21.566v-46.902c0-7.9761 1.8096-14.528 5.374-19.473 3.5244-4.8901 8.2158-7.3687 13.95-7.3687 1.9443 0 4.125 0.3208 6.4854 0.95166 2.3359 0.63086 4.0303 1.3154 5.0283 2.0352l0.9082 0.6538v-21.743l-0.34961-0.14697c-2.0059-0.85352-4.8496-1.2847-8.4473-1.2847" />
              <path d="m664.32 76.783c-15.122 0-27.129 4.4297-35.689 13.17-8.5596 8.7329-12.896 20.828-12.896 35.946 0 14.354 4.2363 25.899 12.588 34.314 8.3535 8.4106 19.724 12.679 33.786 12.679 14.652 0 26.426-4.4907 34.985-13.35 8.5527-8.8506 12.892-20.823 12.892-35.591 0-14.586-4.0703-26.217-12.096-34.57-8.0312-8.3599-19.328-12.598-33.569-12.598m17.147 70.598c-4.0518 5.083-10.147 7.6567-18.122 7.6567-7.9229 0-14.174-2.6245-18.573-7.8013-4.4287-5.2026-6.6748-12.619-6.6748-22.047 0-9.7178 2.2461-17.33 6.6748-22.621 4.4062-5.2642 10.596-7.9302 18.398-7.9302 7.5674 0 13.595 2.5479 17.913 7.5815 4.3389 5.0557 6.5381 12.607 6.5381 22.44 0 9.9604-2.0713 17.602-6.1543 22.721" />
              <path d="m757.82 116.88c-6.7998-2.7314-11.156-4.9971-12.946-6.7295-1.7314-1.6821-2.6133-4.0552-2.6133-7.0645 0-2.666 1.0879-4.8042 3.3193-6.5322 2.2412-1.7388 5.3672-2.623 9.2871-2.623 3.6406 0 7.3633 0.57422 11.062 1.7007 3.6943 1.125 6.9463 2.6338 9.6592 4.4785l0.89551 0.60791v-19.938l-0.34863-0.14746c-2.5-1.0713-5.7969-1.9907-9.8027-2.7349-3.9961-0.73828-7.6133-1.1128-10.76-1.1128-10.286 0-18.792 2.6304-25.293 7.8179-6.5352 5.2183-9.8516 12.06-9.8516 20.342 0 4.3032 0.7168 8.1279 2.125 11.365 1.4141 3.2568 3.6104 6.127 6.5274 8.5288 2.8848 2.3804 7.3535 4.8789 13.269 7.4238 4.9697 2.0425 8.6787 3.7754 11.038 5.1411 2.3018 1.3354 3.9365 2.6812 4.8555 3.9888 0.89941 1.2817 1.3574 3.0312 1.3574 5.1968 0 6.165-4.6143 9.1582-14.104 9.1582-3.5244 0-7.5391-0.73389-11.938-2.1841-4.4033-1.4473-8.5166-3.5317-12.223-6.1973l-0.90723-0.65234v21.023l0.33008 0.15381c3.0918 1.4238 6.9844 2.6289 11.578 3.5757 4.5898 0.94873 8.749 1.4287 12.359 1.4287 11.165 0 20.148-2.6455 26.706-7.8608 6.5967-5.2505 9.9443-12.255 9.9443-20.828 0-6.1807-1.7988-11.481-5.3506-15.753-3.5234-4.2388-9.6396-8.1343-18.176-11.572" />
              <path d="m839.33 76.783c-15.121 0-27.125 4.4297-35.688 13.17-8.5566 8.7329-12.896 20.828-12.896 35.946 0 14.354 4.2344 25.899 12.59 34.314 8.3535 8.4106 19.72 12.679 33.786 12.679 14.652 0 26.422-4.4907 34.981-13.35 8.5566-8.8506 12.896-20.823 12.896-35.591 0-14.586-4.0703-26.217-12.099-34.57-8.0303-8.3599-19.329-12.598-33.57-12.598m17.151 70.598c-4.0518 5.083-10.151 7.6567-18.122 7.6567-7.9228 0-14.174-2.6245-18.575-7.8013-4.4277-5.2026-6.6738-12.619-6.6738-22.047 0-9.7178 2.2471-17.33 6.6768-22.621 4.4014-5.2642 10.591-7.9302 18.396-7.9302 7.5654 0 13.596 2.5479 17.914 7.5815 4.3389 5.0557 6.5381 12.607 6.5381 22.44 0 9.9604-2.0752 17.602-6.1543 22.721" />
              <path d="m1e3 96.582v-17.59h-21.843v-27.346l-0.73633 0.2251-20.514 6.2788-0.4043 0.12451v20.718h-32.361v-11.542c0-5.373 1.2031-9.4863 3.5742-12.226 2.3545-2.7163 5.7158-4.0933 10.001-4.0933 3.085 0 6.2803 0.72949 9.4951 2.1641l0.80274 0.35791v-18.526l-0.37598-0.13477c-2.9961-1.0791-7.0752-1.6255-12.131-1.6255-6.3721 0-12.161 1.3921-17.206 4.1348-5.0527 2.7534-9.0264 6.6821-11.809 11.676-2.7773 4.9863-4.1836 10.747-4.1836 17.122v12.692h-15.21v17.59h15.21v74.1h21.832v-74.1h32.361v47.089c0 19.39 9.1475 29.22 27.188 29.22 2.9648 0 6.0879-0.34668 9.2715-1.0298 3.2441-0.69824 5.4512-1.3965 6.751-2.1411l0.28711-0.16406v-17.76l-0.88867 0.59082c-1.1797 0.79346-2.6582 1.438-4.3896 1.917-1.7402 0.48828-3.1894 0.73193-4.3106 0.73193-4.2285 0-7.3564-1.1372-9.2959-3.3838-1.9619-2.2686-2.958-6.2314-2.958-11.784v-43.286z" />
            </g>
            <g className={classes.m365Txt} strokeWidth="15.367">
              <path d="m1052 165.94v-19.392q12.76 9.874 28.801 9.874 13.033 0 20.78-5.7821 7.8381-5.7821 7.8381-15.656 0-21.705-33.996-21.705h-10.117v-16.546h9.661q30.168 0 30.168-20.46 0-18.858-23.514-18.858-13.124 0-24.699 9.1624v-18.325q13.307-7.2943 31.444-7.2943 17.408 0 27.889 8.5397 10.481 8.5397 10.481 21.883 0 25.174-26.249 32.38v0.35583q14.127 1.3343 22.33 9.6961 8.2028 8.2728 8.2028 20.726 0 17.168-13.216 27.754-13.216 10.497-34.816 10.497-19.413 0-30.988-6.8495z" />
              <path d="m1231.4 129.65q0 9.6071-3.2811 17.524-3.1898 7.917-8.9317 13.699-5.7419 5.6931-13.671 8.8955-7.8381 3.1134-17.043 3.1134-9.8433 0-18.137-3.7361-8.2026-3.7361-14.218-11.119-5.9242-7.3833-9.2053-18.325-3.2811-11.03-3.2811-25.53 0-17.702 4.2836-31.401 4.3748-13.699 11.94-22.95 7.5646-9.2513 17.772-14.055 10.208-4.8036 22.056-4.8036 7.3825 0 13.398 0.9785 6.1065 0.9785 9.7521 2.6686v18.592q-4.6482-2.3128-9.9344-3.914-5.2862-1.6012-12.122-1.6012-7.6559 0-14.127 3.0245-6.4711 3.0245-11.21 8.8955-4.6483 5.7821-7.3825 14.411-2.643 8.5397-2.7342 19.748h0.5469q4.1924-6.3158 11.301-9.9629 7.2002-3.6472 16.861-3.6472 8.5673 0 15.403 2.7576 6.9268 2.6686 11.757 7.828 4.9215 5.0704 7.5646 12.454 2.6431 7.2943 2.6431 16.457zm-21.327 1.6902q0-5.5152-1.3671-10.052-1.276-4.5367-4.0102-7.7391-2.6431-3.2913-6.7445-5.0704-4.0102-1.7791-9.4787-1.7791t-9.661 1.957q-4.1014 1.868-6.9268 4.9815-2.8254 3.1134-4.2836 7.1164-1.367 4.003-1.367 8.1838 0 4.5367 1.2758 9.3403 1.3672 4.7146 4.1014 8.6286 2.7343 3.914 6.9268 6.4937 4.2836 2.4907 10.117 2.4907 5.195 0 9.2053-1.868 4.0102-1.868 6.6533-5.1594 2.7342-3.2913 4.1014-7.7391 1.4582-4.5367 1.4582-9.785z" />
              <path d="m1242.7 167.72v-19.837q12.851 8.4507 26.066 8.4507 13.307 0 21.418-6.5827 8.1116-6.6716 8.1116-17.702 0-10.853-8.2939-16.901-8.2028-6.0489-23.606-6.0489-5.2862 0-21.418 1.0675l4.6482-67.072h64.346v17.613h-46.756l-2.1874 31.935q6.2888-0.35582 11.393-0.35582 20.78 0 32.082 10.408 11.393 10.408 11.393 28.466 0 18.947-13.033 30.423-12.942 11.386-35.636 11.386-19.14 0-28.527-5.2483z" />
            </g>
          </g>
        </svg>
      );
      break;
    case "sentinelone/poll":
      svg = (
        <svg
          width={props.width}
          height={props.height}
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 567.24 95.88"
        >
          <g>
            <path
              className={classes.sentinelLogo}
              d="M48.13,95.88l12.91-8V21a32.21,32.21,0,0,0-12.91-5.72Z"
            />
            <path
              className={classes.sentinelLogo}
              d="M16,87.92l12.92,8V15.32A32.19,32.19,0,0,0,16,21Z"
            />
            <rect
              className={classes.sentinelLogo}
              x="32.08"
              width="12.92"
              height="77.25"
            />
            <path
              className={classes.sentinelLogo}
              d="M64.17,3.67V86.48l6-3.72a15.3,15.3,0,0,0,6.89-13V30.65C77.09,19.37,64.17,3.67,64.17,3.67Z"
            />
            <path
              className={classes.sentinelLogo}
              d="M0,69.73a15.27,15.27,0,0,0,6.89,13l6,3.72V3.67S0,19.37,0,30.65Z"
            />
            <path
              className={classes.sentinelTxt}
              d="M386.68,78.16V17.24L396,13.32V78.16ZM372,52.64a11.52,11.52,0,0,0-3.69-8.79,12.59,12.59,0,0,0-8.77-3.28,12.16,12.16,0,0,0-8.65,3.28,13.24,13.24,0,0,0-4,8.79ZM359.36,78.89q-9.83,0-16-6.32T337.23,55.8q0-10.44,6.23-16.73t16.11-6.27q9.89,0,16,6t6.15,15.76a27.23,27.23,0,0,1-.33,4.37h-34.6a12.7,12.7,0,0,0,3.81,8.87,12.25,12.25,0,0,0,8.73,3.28q7.63,0,10.74-6.24h10.09A20,20,0,0,1,372.73,75,22.14,22.14,0,0,1,359.36,78.89ZM300.73,33.53v7q4.5-7.77,14.43-7.77a16.93,16.93,0,0,1,12.58,5q5,5,5,14V78.16h-9.26V53.21q0-6-3-9.19a10.83,10.83,0,0,0-8.28-3.2A11,11,0,0,0,303.8,44q-3.07,3.19-3.07,9.19V78.16h-9.35V33.53ZM274,78.16V33.53h9.35V78.16Zm-6.77-37.1h-11v24.7a4.72,4.72,0,0,0,1.19,3.61c.79.73,2.14,1.09,4.06,1.09h5.74v7.7h-7.38q-13,0-13-12.4V26.34l9.43-3.91v11.1h11Zm-56.69-7.53v7Q215,32.8,225,32.8a17,17,0,0,1,12.59,5q5,5,5,14V78.16h-9.27V53.21q0-6-3-9.19a10.83,10.83,0,0,0-8.28-3.2A11,11,0,0,0,213.6,44q-3.07,3.19-3.08,9.19V78.16h-9.34V33.53Zm-24,19.11a11.52,11.52,0,0,0-3.69-8.79A12.59,12.59,0,0,0,174,40.57a12.16,12.16,0,0,0-8.65,3.28,13.19,13.19,0,0,0-4,8.79ZM173.86,78.89q-9.84,0-16-6.32T151.72,55.8q0-10.44,6.23-16.73t16.11-6.27q9.88,0,16,6t6.15,15.76a27.23,27.23,0,0,1-.33,4.37h-34.6a12.66,12.66,0,0,0,3.82,8.87,12.21,12.21,0,0,0,8.73,3.28q7.62,0,10.74-6.24h10.08A20,20,0,0,1,187.22,75,22.13,22.13,0,0,1,173.86,78.89ZM127.27,28.67a10.54,10.54,0,0,0-6.8,2.1,7.39,7.39,0,0,0-2.63,6.12A6.91,6.91,0,0,0,121,43a21.56,21.56,0,0,0,7.54,3.08q4.42,1,8.85,2.23A15.94,15.94,0,0,1,144.9,53q3.1,3.39,3.11,9.64t-5.33,11.17q-5.33,4.95-14.26,5t-14.51-4.14a13.41,13.41,0,0,1-5.58-11.42h10a8.6,8.6,0,0,0,2.79,5.92q2.46,2.18,7.22,2.18a10.91,10.91,0,0,0,7.5-2.43,8,8,0,0,0,1.06-10.93,10.27,10.27,0,0,0-4.34-2.8,56,56,0,0,0-5.86-1.66q-3.2-.72-6.44-1.7a27.57,27.57,0,0,1-5.9-2.51,11.71,11.71,0,0,1-4.35-4.5,14.44,14.44,0,0,1-1.68-7.24,14.72,14.72,0,0,1,5.37-11.87q5.37-4.5,13.94-4.5T141.33,25q5.13,3.89,5.7,11.26H136.7a8.14,8.14,0,0,0-2.79-5.43A9.61,9.61,0,0,0,127.27,28.67Z"
            />
            <path
              className={classes.sentinelTxt}
              d="M532.86,36.07a19.44,19.44,0,0,0-8.84,2,15.82,15.82,0,0,0-6.51,6.1,19.76,19.76,0,0,0-2.58,10.12H550a18.2,18.2,0,0,0-2.05-10.16,14.78,14.78,0,0,0-6.39-6.1A19.46,19.46,0,0,0,532.86,36.07Zm-.16,38.71A18.65,18.65,0,0,0,544,71.44a13.63,13.63,0,0,0,5.57-9.11h3.85a17.64,17.64,0,0,1-6.68,11.24q-5.44,4.26-13.88,4.26a22.74,22.74,0,0,1-11.17-2.69A19.25,19.25,0,0,1,514,67.39a24.4,24.4,0,0,1-2.78-12A24.2,24.2,0,0,1,514,43.54a19.31,19.31,0,0,1,7.66-7.75,22.74,22.74,0,0,1,11.17-2.69A22.19,22.19,0,0,1,544,35.79a18.26,18.26,0,0,1,7.12,7.07,19.05,19.05,0,0,1,2.42,9.35,24.11,24.11,0,0,1-.41,4.26H514.93a20.14,20.14,0,0,0,2.58,10.24,15.58,15.58,0,0,0,6.47,6.1A19.39,19.39,0,0,0,532.7,74.78Zm-45.55-42q7.86,0,12.78,4.82t4.91,14.21V77.27h-3.68V52c0-5.24-1.34-9.25-4-12s-6.33-4.14-11-4.14a15.24,15.24,0,0,0-11.59,4.62q-4.38,4.62-4.38,13.61V77.27h-3.68V33.66h3.68V45.15a15.57,15.57,0,0,1,6.27-9.24A18.56,18.56,0,0,1,487.15,32.78ZM431.7,24.44a24.09,24.09,0,0,0-12.24,3.14,22.31,22.31,0,0,0-8.6,8.91A27.75,27.75,0,0,0,407.71,50a27.75,27.75,0,0,0,3.15,13.49,22.37,22.37,0,0,0,8.6,8.91,25.42,25.42,0,0,0,24.44,0,22.27,22.27,0,0,0,8.64-8.91A27.75,27.75,0,0,0,455.69,50a27.75,27.75,0,0,0-3.15-13.49,22.2,22.2,0,0,0-8.64-8.91A24.15,24.15,0,0,0,431.7,24.44Zm0-3.29A28.09,28.09,0,0,1,446,24.81,25.62,25.62,0,0,1,455.9,35,31,31,0,0,1,459.46,50a31,31,0,0,1-3.56,14.94A26,26,0,0,1,446,75.19a29.45,29.45,0,0,1-28.58,0,26.21,26.21,0,0,1-10-10.27A30.63,30.63,0,0,1,403.86,50,30.63,30.63,0,0,1,407.46,35a25.85,25.85,0,0,1,10-10.23A28.07,28.07,0,0,1,431.7,21.15Z"
            />
            <g>
              <path
                className={classes.sentinelTxt}
                d="M563.47,39.55l-1-1.51h-.82v1.51h-1V34.82h2.16c1.12,0,1.79.59,1.79,1.56v0a1.47,1.47,0,0,1-1,1.46l1.16,1.69Zm0-3.11c0-.45-.31-.68-.82-.68h-1v1.36h1.05c.51,0,.8-.27.8-.67Z"
              />
              <path
                className={classes.sentinelTxt}
                d="m562.4 42.16a4.85 4.85 0 1 1 4.84 -4.84 4.85 4.85 0 0 1 -4.84 4.84zm0-8.63a3.79 3.79 0 1 0 3.79 3.79 3.79 3.79 0 0 0 -3.79 -3.79z"
              />
            </g>
          </g>
        </svg>
      );
      break;
    case "mimecast/poll":
      svg = (
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
          viewBox="0 0 5334.000000 1551.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0.000000,1551.000000) scale(0.100000,-0.100000)"
            fill="#000000"
            stroke="none"
          >
            <path
              className={classes.mimecastText}
              d="M13890 10470 l0 -600 640 0 640 0 0 600 0 600 -640 0 -640 0 0 -600z"
            />
            <path
              className={classes.mimecastText}
              d="M41940 8073 c0 -2649 -1 -2565 49 -2775 67 -283 201 -510 387 -658 188 -150 401 -234 692 -274 94 -13 244 -16 927 -16 l815 0 0 534 0 535 -712 3 c-801 4 -771 1 -849 79 -73 73 -69 2 -69 1331 l0 1188 770 0 770 0 0 540 0 540 -770 0 -770 0 0 725 0 725 -620 0 -620 0 0 -2477z"
            />
            <path
              className={classes.mimecastText}
              d="M6880 6725 l0 -2375 620 0 620 0 0 1835 0 1835 595 0 595 0 0 -1835 0 -1835 625 0 625 0 0 1836 0 1835 493 -3 c435 -3 497 -5 535 -21 69 -27 99 -53 129 -115 l28 -57 3 -1737 2 -1738 620 0 620 0 -3 1793 -3 1792 -22 114 c-104 537 -405 867 -902 990 -237 58 -73 55 -2737 58 l-2443 4 0 -2376z"
            />
            <path
              className={classes.mimecastText}
              d="M13910 6725 l0 -2375 620 0 620 0 0 2375 0 2375 -620 0 -620 0 0 -2375z"
            />
            <path
              className={classes.mimecastText}
              d="M16220 6725 l0 -2375 620 0 620 0 0 1835 0 1835 598 -2 597 -3 3 -1832 2 -1833 620 0 620 0 0 1835 0 1835 458 0 c288 0 480 -4 517 -11 76 -14 127 -40 159 -82 59 -78 56 38 56 -1848 l0 -1729 625 0 626 0 -4 1758 c-4 1922 -1 1826 -62 2067 -114 451 -409 746 -860 860 -246 63 -69 59 -2752 62 l-2443 4 0 -2376z"
            />
            <path
              className={classes.mimecastText}
              d="M24520 9089 c-655 -47 -1057 -351 -1201 -907 -59 -228 -59 -236 -59 -1465 0 -1190 1 -1220 49 -1419 29 -125 57 -201 117 -318 178 -350 498 -553 967 -615 102 -13 314 -15 1533 -15 l1414 0 0 535 0 534 -1317 3 c-1263 3 -1320 4 -1367 22 -27 10 -66 37 -87 59 -64 65 -69 97 -69 444 l0 303 1420 0 1420 0 0 764 c0 438 -4 808 -10 867 -50 517 -260 864 -637 1053 -183 92 -366 136 -638 156 -160 11 -1376 11 -1535 -1z m1420 -1092 c59 -23 115 -80 137 -136 16 -40 18 -83 18 -341 l0 -295 -798 -3 -798 -2 3 308 c3 308 3 308 29 357 31 62 90 104 166 121 44 10 200 12 628 11 520 -2 574 -4 615 -20z"
            />
            <path
              className={classes.mimecastText}
              d="M29490 9090 c-447 -33 -786 -191 -990 -462 -116 -154 -197 -349 -242 -585 l-23 -118 0 -1200 0 -1200 22 -124 c100 -546 407 -880 921 -1002 201 -48 222 -49 1510 -49 l1212 0 0 535 0 534 -1112 3 c-1017 3 -1117 5 -1155 20 -64 26 -98 55 -130 112 l-28 51 0 1115 0 1115 26 50 c33 66 96 109 182 124 44 8 395 11 1140 11 l1077 0 0 540 0 540 -1152 -1 c-634 -1 -1200 -5 -1258 -9z"
            />
            <path
              className={classes.mimecastText}
              d="M32910 8561 l0 -541 1123 -2 c1036 -3 1125 -4 1165 -20 69 -28 99 -55 129 -116 l28 -57 3 -307 3 -308 -648 0 c-356 0 -706 -5 -776 -10 -410 -30 -698 -142 -913 -355 -206 -203 -319 -477 -354 -860 -34 -372 21 -738 150 -996 155 -308 413 -501 788 -590 202 -48 212 -49 1645 -49 l1347 0 0 1730 c0 1151 -4 1763 -11 1828 -66 609 -369 988 -902 1126 -232 60 -200 59 -1544 63 l-1233 4 0 -540z m2450 -2736 l0 -405 -577 0 c-325 0 -608 5 -646 10 -113 17 -167 54 -209 145 -22 47 -23 62 -23 255 0 193 2 208 23 256 29 65 65 99 128 124 46 18 83 19 677 20 l627 0 0 -405z"
            />
            <path
              className={classes.mimecastText}
              d="M38787 9089 c-362 -26 -662 -142 -866 -335 -99 -93 -163 -180 -226 -309 -115 -234 -158 -451 -159 -790 -1 -293 34 -474 128 -670 125 -260 328 -444 616 -556 159 -63 250 -82 835 -180 297 -49 562 -97 590 -106 34 -11 66 -33 101 -68 70 -70 98 -155 98 -300 1 -125 -20 -200 -71 -256 -48 -53 -96 -77 -180 -89 -41 -6 -477 -10 -1095 -10 l-1028 0 0 -535 0 -535 1183 0 c1255 0 1279 1 1478 49 240 57 418 151 577 305 179 173 289 400 342 706 28 162 38 445 20 601 -48 444 -250 758 -607 942 -206 106 -297 129 -983 242 -291 49 -549 96 -579 108 -70 25 -133 89 -163 165 -19 49 -22 75 -23 197 0 125 2 145 23 190 30 65 73 108 136 137 l51 23 968 3 967 3 0 539 0 540 -1007 -1 c-555 -1 -1061 -6 -1126 -10z"
            />
            <path
              className={classes.mimecastText}
              d="M45903 9086 c-149 -49 -235 -162 -235 -311 0 -127 66 -234 179 -290 51 -26 69 -29 148 -30 79 0 97 4 146 28 67 32 132 100 162 165 32 73 29 191 -6 264 -32 65 -100 132 -164 160 -58 25 -174 33 -230 14z m192 -75 c51 -23 118 -98 133 -149 15 -51 15 -124 0 -176 -18 -59 -99 -138 -161 -155 -207 -58 -385 157 -293 355 26 56 84 111 137 130 51 19 138 16 184 -5z"
            />
            <path
              className={classes.mimecastText}
              d="M45888 8933 c-16 -4 -18 -20 -18 -164 l0 -159 40 0 40 0 0 65 c0 58 2 65 20 65 44 0 67 -21 81 -74 14 -51 14 -51 57 -54 38 -3 43 -1 38 15 -2 10 -10 37 -16 61 -6 24 -19 51 -28 60 -17 16 -16 18 10 44 45 42 32 109 -27 133 -32 14 -156 19 -197 8z m160 -71 c16 -21 15 -29 -8 -52 -12 -12 -33 -20 -55 -20 -35 0 -35 0 -35 44 0 26 5 46 13 49 20 9 71 -4 85 -21z"
            />
          </g>
        </svg>
      );
      break;
    case "webroot/poll":
      svg = (
        <svg
          version="1.1"
          width={props.width}
          height={props.height}
          viewBox="0 0 1280 720"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="transparent"
            opacity="1.000000"
            stroke="none"
            d="M849.000000,721.000000 

            C566.035278,721.000000 283.570557,721.000000 1.052914,721.000000 

            C1.052914,481.065247 1.052914,241.130493 1.052914,1.097868 

            C427.548126,1.097868 854.096252,1.097868 1280.822266,1.097868 

            C1280.822266,240.999893 1280.822266,480.999939 1280.822266,721.000000 

            C1137.130371,721.000000 993.315186,721.000000 849.000000,721.000000 

            M391.475037,345.499878 

            C391.475037,370.793030 391.475037,396.086151 391.475037,422.014526 

            C405.964050,423.197083 420.011566,424.786621 434.101501,425.399689 

            C461.903290,426.609344 489.718750,426.687805 517.456665,423.822113 

            C526.106445,422.928497 531.875244,418.069672 534.916626,410.123047 

            C536.210754,406.741669 537.227844,403.087463 537.464600,399.497467 

            C538.416626,385.065613 538.863159,370.659668 525.973633,361.706116 

            C529.247681,356.777863 533.508850,352.324402 535.445618,347.021912 

            C538.982239,337.339355 538.978882,327.052307 536.491211,316.979401 

            C533.424988,304.563751 527.276489,298.888367 514.558594,298.234406 

            C493.116272,297.131805 471.629242,296.034088 450.175690,296.269348 

            C430.765106,296.482178 411.374084,298.479248 391.475403,299.720673 

            C391.475403,315.265808 391.475403,329.882843 391.475037,345.499878 

            M654.356689,392.194092 

            C657.876831,397.646210 661.374146,403.113190 664.923462,408.546265 

            C668.467407,413.971283 670.924133,421.506104 675.950623,424.177185 

            C681.185547,426.959015 688.921753,425.073608 695.565186,425.152405 

            C700.911499,425.215820 706.259216,425.165253 712.399170,425.165253 

            C701.778748,409.517487 691.790222,394.800812 681.394226,379.483795 

            C683.741089,379.285950 684.881653,379.169250 686.024963,379.096527 

            C700.680969,378.164276 708.782532,371.639771 710.239136,357.011414 

            C711.467773,344.672546 711.414307,332.062561 710.448730,319.687988 

            C709.432495,306.663208 700.269958,299.020599 687.147461,298.097534 

            C685.320679,297.969025 683.487976,297.915588 681.664062,297.757538 

            C649.237061,294.946808 616.827332,295.386993 584.437744,298.336884 

            C578.047180,298.918945 571.681152,299.770172 565.465454,300.478851 

            C565.465454,342.334747 565.465454,383.562744 565.465454,424.915222 

            C576.211243,424.915222 586.635376,424.915222 597.586792,424.915222 

            C597.586792,409.937866 597.586792,395.205841 597.586792,380.198395 

            C600.237488,380.198395 602.364258,380.143921 604.487427,380.207703 

            C614.469849,380.507477 624.519104,381.696930 634.413452,380.913757 

            C643.879761,380.164429 650.388367,382.620514 654.356689,392.194092 

            M131.313583,401.229614 

            C133.918793,406.983612 136.312637,412.847839 139.228638,418.439789 

            C140.471542,420.823303 142.413513,423.414642 144.712402,424.574829 

            C154.084473,429.304718 164.613541,424.895172 167.843521,415.007263 

            C174.755249,393.848389 181.636993,372.676636 188.202362,351.408661 

            C193.732529,333.494141 198.798264,315.436218 204.144089,297.187408 

            C192.814697,297.187408 182.074890,297.187408 171.886520,297.187408 

            C164.271805,322.682983 156.799820,347.700623 149.327835,372.718262 

            C148.770554,372.634583 148.213257,372.550903 147.655975,372.467224 

            C147.011017,371.192017 146.319946,369.937805 145.728073,368.638428 

            C137.731689,351.083405 129.629715,333.574585 121.867966,315.916260 

            C120.387566,312.548279 118.586929,311.559540 115.161850,311.750427 

            C110.345993,312.018890 105.493729,312.014252 100.676872,311.756134 

            C97.253235,311.572693 95.407692,312.557251 93.925438,315.928375 

            C86.164368,333.579773 78.077484,351.087952 70.092003,368.640503 

            C69.433533,370.087830 68.686531,371.494904 67.587029,373.715790 

            C66.112617,369.666840 64.822075,366.611816 63.878685,363.453064 

            C57.603859,342.442871 51.429916,321.402496 45.115551,300.404297 

            C44.717194,299.079559 43.436623,297.024323 42.525467,297.002258 

            C32.435921,296.757874 22.338264,296.848450 12.277600,296.848450 

            C12.235003,297.773621 12.126838,298.131775 12.217817,298.428986 

            C24.277208,337.825989 36.275570,377.242035 48.492653,416.590149 

            C50.749222,423.858032 54.238705,425.788971 62.480923,426.003357 

            C70.715836,426.217560 73.986885,424.280334 77.095932,417.416656 

            C86.699654,396.215027 96.311974,375.017303 105.935318,353.824554 

            C106.434853,352.724518 107.067543,351.684875 108.072563,349.804504 

            C115.985687,367.300659 123.500717,383.916595 131.313583,401.229614 

            M769.963562,297.465607 

            C766.320007,297.813110 762.647278,297.975311 759.038269,298.542603 

            C747.948975,300.285858 739.370361,308.596497 739.177795,319.691223 

            C738.701477,347.141693 738.677979,374.611664 739.158508,402.061798 

            C739.368469,414.055664 748.905273,422.982422 760.544800,423.971252 

            C793.463318,426.767822 826.355957,426.541809 859.329468,424.345886 

            C873.251648,423.418701 883.598938,413.523834 883.761475,399.255737 

            C884.051514,373.789581 884.100281,348.314331 883.750854,322.849762 

            C883.556335,308.678162 874.714417,299.508514 861.187439,298.237885 

            C831.114807,295.413208 801.012512,295.210327 769.963562,297.465607 

            M1045.456543,417.990448 

            C1050.087158,413.311951 1053.052856,407.725037 1053.090698,401.126770 

            C1053.240967,374.986847 1053.460693,348.841125 1053.061768,322.706573 

            C1052.829102,307.452393 1043.883789,299.264221 1028.635010,297.986176 

            C996.856934,295.322815 965.113525,295.341034 933.335388,297.967163 

            C917.729248,299.256805 909.080017,307.222137 908.518066,322.967041 

            C907.876587,340.938416 907.986572,358.939392 907.941650,376.927948 

            C907.921265,385.085236 907.980957,393.268890 908.598328,401.395477 

            C909.552917,413.960388 918.343811,422.933746 930.003418,423.983368 

            C960.759949,426.752228 991.549072,426.739471 1022.335510,424.768524 

            C1030.214111,424.264160 1038.488037,424.455566 1045.456543,417.990448 

            M364.026123,318.589417 

            C364.491974,312.029144 364.957794,305.468872 365.491974,297.946228 

            C351.881989,297.299225 338.947021,296.064270 326.026337,296.199310 

            C299.234650,296.479279 272.440094,297.228394 245.667816,298.307800 

            C232.861252,298.824158 223.356339,307.857697 223.150253,320.048492 

            C222.689011,347.333557 222.725281,374.635925 223.137726,401.922516 

            C223.307999,413.187073 232.336807,422.436951 242.947922,423.765076 

            C247.898148,424.384705 252.893265,424.874054 257.876343,424.964294 

            C282.018005,425.401581 306.162659,425.931671 330.305878,425.912598 

            C341.881439,425.903442 353.456146,424.750977 365.535980,424.088654 

            C364.783783,414.003082 364.114899,405.034424 363.535248,397.262115 

            C339.709381,397.654205 316.773071,398.219299 293.834656,398.323029 

            C283.696686,398.368896 273.553986,397.489105 263.414368,397.010162 

            C259.386566,396.819946 255.800339,395.266235 255.358780,391.020630 

            C254.786804,385.521088 255.219238,379.917023 255.219238,373.953369 

            C279.444214,373.953369 303.526886,373.953369 327.761963,373.953369 

            C327.761963,365.146545 327.761963,356.748810 327.761963,347.803345 

            C303.294342,347.803345 279.078552,347.803345 254.579865,347.803345 

            C254.579865,345.930298 254.550507,344.606079 254.585739,343.283569 

            C254.669998,340.121368 254.705566,336.955048 254.904266,333.799377 

            C255.273621,327.933289 257.711304,325.153534 263.655273,325.101593 

            C291.949097,324.854401 320.244934,324.772919 348.539978,324.793121 

            C353.422424,324.796631 358.304352,325.575562 363.442688,326.018372 

            C363.663483,323.461914 363.833923,321.488434 364.026123,318.589417 

            M1173.500000,296.999207 

            C1139.119263,296.999207 1104.738525,296.999207 1070.454590,296.999207 

            C1070.454590,306.745911 1070.454590,315.670166 1070.454590,325.131836 

            C1091.797974,325.131836 1112.853027,325.131836 1134.374634,325.131836 

            C1134.374634,358.735474 1134.374634,391.795959 1134.374634,424.850037 

            C1145.268799,424.850037 1155.682251,424.850037 1166.661133,424.850037 

            C1166.661133,391.495636 1166.661133,358.453979 1166.661133,324.893250 

            C1188.120605,324.893250 1209.015015,324.893250 1229.804077,324.893250 

            C1229.804077,315.312836 1229.804077,306.263153 1229.804077,296.999207 

            C1211.109863,296.999207 1192.804932,296.999207 1173.500000,296.999207 

            M1245.712891,321.906311 

            C1246.878906,322.543610 1247.979858,323.382599 1249.222168,323.783783 

            C1255.105469,325.683929 1260.392700,324.675812 1264.818359,320.187653 

            C1268.870361,316.078491 1269.995972,309.834137 1267.717041,304.441437 

            C1265.477173,299.141571 1260.325073,295.930634 1254.236328,295.910339 

            C1247.831177,295.888977 1243.352783,298.986145 1241.019165,304.712524 

            C1238.418091,311.094666 1240.058350,316.772614 1245.712891,321.906311 z"
          />
          <path
            className={classes.webrootText}
            opacity="1.000000"
            stroke="none"
            d="M391.475220,344.999878 

            C391.475403,329.882843 391.475403,315.265808 391.475403,299.720673 

            C411.374084,298.479248 430.765106,296.482178 450.175690,296.269348 

            C471.629242,296.034088 493.116272,297.131805 514.558594,298.234406 

            C527.276489,298.888367 533.424988,304.563751 536.491211,316.979401 

            C538.978882,327.052307 538.982239,337.339355 535.445618,347.021912 

            C533.508850,352.324402 529.247681,356.777863 525.973633,361.706116 

            C538.863159,370.659668 538.416626,385.065613 537.464600,399.497467 

            C537.227844,403.087463 536.210754,406.741669 534.916626,410.123047 

            C531.875244,418.069672 526.106445,422.928497 517.456665,423.822113 

            C489.718750,426.687805 461.903290,426.609344 434.101501,425.399689 

            C420.011566,424.786621 405.964050,423.197083 391.475037,422.014526 

            C391.475037,396.086151 391.475037,370.793030 391.475220,344.999878 

           M455.506104,323.897339 

            C445.085022,324.466949 434.663971,325.036591 424.195801,325.608795 

            C424.195801,333.734924 424.195801,341.110016 424.195801,348.852142 

            C437.201813,348.852142 449.834747,349.052551 462.458191,348.793365 

            C474.095734,348.554413 485.741425,348.069275 497.348053,347.212463 

            C504.103760,346.713776 506.256165,343.037292 505.825409,334.694244 

            C505.470642,327.822906 503.164825,325.280334 496.426178,325.029877 

            C483.122284,324.535400 469.811188,324.233490 455.506104,323.897339 

            M449.500122,373.575165 

            C441.081451,373.575165 432.662781,373.575165 424.177856,373.575165 

            C424.177856,381.503937 424.177856,388.721436 424.177856,396.313507 

            C449.547363,398.870087 474.601746,399.212219 499.657196,396.742401 

            C501.510956,396.559662 503.932587,394.459259 504.743286,392.647644 

            C509.238007,382.603424 504.260681,374.508179 493.414246,374.209167 

            C479.114594,373.814941 464.805298,373.770020 449.500122,373.575165 z"
          />

          <path
            className={classes.webrootText}
            opacity="1.000000"
            stroke="none"
            d="M654.166748,391.887939 

            C650.388367,382.620514 643.879761,380.164429 634.413452,380.913757 

            C624.519104,381.696930 614.469849,380.507477 604.487427,380.207703 

            C602.364258,380.143921 600.237488,380.198395 597.586792,380.198395 

            C597.586792,395.205841 597.586792,409.937866 597.586792,424.915222 

            C586.635376,424.915222 576.211243,424.915222 565.465454,424.915222 

            C565.465454,383.562744 565.465454,342.334747 565.465454,300.478851 

            C571.681152,299.770172 578.047180,298.918945 584.437744,298.336884 

            C616.827332,295.386993 649.237061,294.946808 681.664062,297.757538 

            C683.487976,297.915588 685.320679,297.969025 687.147461,298.097534 

            C700.269958,299.020599 709.432495,306.663208 710.448730,319.687988 

            C711.414307,332.062561 711.467773,344.672546 710.239136,357.011414 

            C708.782532,371.639771 700.680969,378.164276 686.024963,379.096527 

            C684.881653,379.169250 683.741089,379.285950 681.394226,379.483795 

            C691.790222,394.800812 701.778748,409.517487 712.399170,425.165253 

            C706.259216,425.165253 700.911499,425.215820 695.565186,425.152405 

            C688.921753,425.073608 681.185547,426.959015 675.950623,424.177185 

            C670.924133,421.506104 668.467407,413.971283 664.923462,408.546265 

            C661.374146,403.113190 657.876831,397.646210 654.166748,391.887939 

            M636.500488,324.007874 

            C623.615967,324.561676 610.731445,325.115479 597.429138,325.687225 

            C597.429138,334.061401 597.261230,341.362976 597.606140,348.640198 

            C597.659302,349.761749 600.048157,351.667084 601.392883,351.699097 

            C622.483154,352.201813 643.588928,352.975708 664.670532,352.580994 

            C678.177490,352.328094 679.292297,350.228302 678.980042,336.445892 

            C678.792603,328.175690 676.547974,325.604401 668.408447,325.175323 

            C658.113770,324.632690 647.803650,324.383575 636.500488,324.007874 z"
          />

          <path
            className={classes.webrootText}
            opacity="1.000000"
            stroke="none"
            d="M131.164673,400.881104 

            C123.500717,383.916595 115.985687,367.300659 108.072563,349.804504 

            C107.067543,351.684875 106.434853,352.724518 105.935318,353.824554 

            C96.311974,375.017303 86.699654,396.215027 77.095932,417.416656 

            C73.986885,424.280334 70.715836,426.217560 62.480923,426.003357 

            C54.238705,425.788971 50.749222,423.858032 48.492653,416.590149 

            C36.275570,377.242035 24.277208,337.825989 12.217817,298.428986 

            C12.126838,298.131775 12.235003,297.773621 12.277600,296.848450 

            C22.338264,296.848450 32.435921,296.757874 42.525467,297.002258 

            C43.436623,297.024323 44.717194,299.079559 45.115551,300.404297 

            C51.429916,321.402496 57.603859,342.442871 63.878685,363.453064 

            C64.822075,366.611816 66.112617,369.666840 67.587029,373.715790 

            C68.686531,371.494904 69.433533,370.087830 70.092003,368.640503 

            C78.077484,351.087952 86.164368,333.579773 93.925438,315.928375 

            C95.407692,312.557251 97.253235,311.572693 100.676872,311.756134 

            C105.493729,312.014252 110.345993,312.018890 115.161850,311.750427 

            C118.586929,311.559540 120.387566,312.548279 121.867966,315.916260 

            C129.629715,333.574585 137.731689,351.083405 145.728073,368.638428 

            C146.319946,369.937805 147.011017,371.192017 147.655975,372.467224 

            C148.213257,372.550903 148.770554,372.634583 149.327835,372.718262 

            C156.799820,347.700623 164.271805,322.682983 171.886520,297.187408 

            C182.074890,297.187408 192.814697,297.187408 204.144089,297.187408 

            C198.798264,315.436218 193.732529,333.494141 188.202362,351.408661 

            C181.636993,372.676636 174.755249,393.848389 167.843521,415.007263 

            C164.613541,424.895172 154.084473,429.304718 144.712402,424.574829 

            C142.413513,423.414642 140.471542,420.823303 139.228638,418.439789 

            C136.312637,412.847839 133.918793,406.983612 131.164673,400.881104 z"
          />

          <path
            className={classes.webrootText}
            opacity="1.000000"
            stroke="none"
            d="M770.426880,297.426758 

            C801.012512,295.210327 831.114807,295.413208 861.187439,298.237885 

            C874.714417,299.508514 883.556335,308.678162 883.750854,322.849762 

            C884.100281,348.314331 884.051514,373.789581 883.761475,399.255737 

            C883.598938,413.523834 873.251648,423.418701 859.329468,424.345886 

            C826.355957,426.541809 793.463318,426.767822 760.544800,423.971252 

            C748.905273,422.982422 739.368469,414.055664 739.158508,402.061798 

            C738.677979,374.611664 738.701477,347.141693 739.177795,319.691223 

            C739.370361,308.596497 747.948975,300.285858 759.038269,298.542603 

            C762.647278,297.975311 766.320007,297.813110 770.426880,297.426758 

            M849.562317,328.009674 

            C846.974548,327.067230 844.394287,325.332520 841.797791,325.307861 

            C821.190247,325.112152 800.576721,325.057251 779.971497,325.376160 

            C773.214783,325.480713 770.909302,328.421478 770.874756,335.280548 

            C770.788635,352.404388 770.786804,369.529327 770.877075,386.653168 

            C770.915283,393.906281 773.441284,396.757721 780.812256,396.834595 

            C801.088318,397.046051 821.369995,397.047058 841.645630,396.806946 

            C849.156982,396.717987 851.742493,393.735413 851.814209,386.212036 

            C851.956970,371.238129 852.079163,356.260925 851.893250,341.289001 

            C851.840820,337.069702 850.688171,332.864014 849.562317,328.009674 z"
          />

          <path
            className={classes.webrootText}
            opacity="1.000000"
            stroke="none"
            d="M1045.205322,418.253235 

            C1038.488037,424.455566 1030.214111,424.264160 1022.335510,424.768524 

            C991.549072,426.739471 960.759949,426.752228 930.003418,423.983368 

            C918.343811,422.933746 909.552917,413.960388 908.598328,401.395477 

            C907.980957,393.268890 907.921265,385.085236 907.941650,376.927948 

            C907.986572,358.939392 907.876587,340.938416 908.518066,322.967041 

            C909.080017,307.222137 917.729248,299.256805 933.335388,297.967163 

            C965.113525,295.341034 996.856934,295.322815 1028.635010,297.986176 

            C1043.883789,299.264221 1052.829102,307.452393 1053.061768,322.706573 

            C1053.460693,348.841125 1053.240967,374.986847 1053.090698,401.126770 

            C1053.052856,407.725037 1050.087158,413.311951 1045.205322,418.253235 

            M1005.612732,324.908173 

            C987.308899,325.000854 969.001709,324.918610 950.702820,325.270111 

            C943.106567,325.416046 940.645813,327.587921 940.521973,334.700531 

            C940.214905,352.343109 940.253052,370.000153 940.617737,387.641724 

            C940.758667,394.456146 943.111023,396.652496 949.957214,396.733856 

            C970.585266,396.979095 991.220154,396.983673 1011.847961,396.727722 

            C1018.711243,396.642578 1020.954712,394.390686 1021.121826,387.603333 

            C1021.519409,371.460938 1021.544250,355.307037 1021.539185,339.157837 

            C1021.535461,327.333618 1019.501953,325.412262 1007.534607,325.006927 

            C1007.201477,324.995636 1006.868286,324.990112 1005.612732,324.908173 z"
          />

          <path
            className={classes.webrootText}
            opacity="1.000000"
            stroke="none"
            d="M364.015259,319.052185 

            C363.833923,321.488434 363.663483,323.461914 363.442688,326.018372 

            C358.304352,325.575562 353.422424,324.796631 348.539978,324.793121 

            C320.244934,324.772919 291.949097,324.854401 263.655273,325.101593 

            C257.711304,325.153534 255.273621,327.933289 254.904266,333.799377 

            C254.705566,336.955048 254.669998,340.121368 254.585739,343.283569 

            C254.550507,344.606079 254.579865,345.930298 254.579865,347.803345 

            C279.078552,347.803345 303.294342,347.803345 327.761963,347.803345 

            C327.761963,356.748810 327.761963,365.146545 327.761963,373.953369 

            C303.526886,373.953369 279.444214,373.953369 255.219238,373.953369 

            C255.219238,379.917023 254.786804,385.521088 255.358780,391.020630 

            C255.800339,395.266235 259.386566,396.819946 263.414368,397.010162 

            C273.553986,397.489105 283.696686,398.368896 293.834656,398.323029 

            C316.773071,398.219299 339.709381,397.654205 363.535248,397.262115 

            C364.114899,405.034424 364.783783,414.003082 365.535980,424.088654 

            C353.456146,424.750977 341.881439,425.903442 330.305878,425.912598 

            C306.162659,425.931671 282.018005,425.401581 257.876343,424.964294 

            C252.893265,424.874054 247.898148,424.384705 242.947922,423.765076 

            C232.336807,422.436951 223.307999,413.187073 223.137726,401.922516 

            C222.725281,374.635925 222.689011,347.333557 223.150253,320.048492 

            C223.356339,307.857697 232.861252,298.824158 245.667816,298.307800 

            C272.440094,297.228394 299.234650,296.479279 326.026337,296.199310 

            C338.947021,296.064270 351.881989,297.299225 365.491974,297.946228 

            C364.957794,305.468872 364.491974,312.029144 364.015259,319.052185 z"
          />

          <path
            className={classes.webrootText}
            opacity="1.000000"
            stroke="none"
            d="M1174.000000,296.999207 

            C1192.804932,296.999207 1211.109863,296.999207 1229.804077,296.999207 

            C1229.804077,306.263153 1229.804077,315.312836 1229.804077,324.893250 

            C1209.015015,324.893250 1188.120605,324.893250 1166.661133,324.893250 

            C1166.661133,358.453979 1166.661133,391.495636 1166.661133,424.850037 

            C1155.682251,424.850037 1145.268799,424.850037 1134.374634,424.850037 

            C1134.374634,391.795959 1134.374634,358.735474 1134.374634,325.131836 

            C1112.853027,325.131836 1091.797974,325.131836 1070.454590,325.131836 

            C1070.454590,315.670166 1070.454590,306.745911 1070.454590,296.999207 

            C1104.738525,296.999207 1139.119263,296.999207 1174.000000,296.999207 z"
          />

          <path
            className={classes.webrootText}
            opacity="1.000000"
            stroke="none"
            d="M1245.430786,321.667450 

            C1240.058350,316.772614 1238.418091,311.094666 1241.019165,304.712524 

            C1243.352783,298.986145 1247.831177,295.888977 1254.236328,295.910339 

            C1260.325073,295.930634 1265.477173,299.141571 1267.717041,304.441437 

            C1269.995972,309.834137 1268.870361,316.078491 1264.818359,320.187653 

            C1260.392700,324.675812 1255.105469,325.683929 1249.222168,323.783783 

            C1247.979858,323.382599 1246.878906,322.543610 1245.430786,321.667450 

            M1251.312134,298.458984 

            C1250.110962,299.021698 1248.791748,299.418976 1247.729614,300.176605 

            C1243.773682,302.998535 1241.610962,306.872162 1242.399536,311.754761 

            C1243.198730,316.702850 1246.008789,320.458252 1251.015137,321.757721 

            C1255.864136,323.016388 1260.313354,321.910950 1263.613281,317.839478 

            C1266.885498,313.802216 1267.250854,309.241821 1264.949951,304.751038 

            C1262.319580,299.617188 1257.824463,297.533417 1251.312134,298.458984 z"
          />

          <path
            fill="transparent"
            opacity="1.000000"
            stroke="none"
            d="M456.004578,323.874634 

            C469.811188,324.233490 483.122284,324.535400 496.426178,325.029877 

            C503.164825,325.280334 505.470642,327.822906 505.825409,334.694244 

            C506.256165,343.037292 504.103760,346.713776 497.348053,347.212463 

            C485.741425,348.069275 474.095734,348.554413 462.458191,348.793365 

            C449.834747,349.052551 437.201813,348.852142 424.195801,348.852142 

            C424.195801,341.110016 424.195801,333.734924 424.195801,325.608795 

            C434.663971,325.036591 445.085022,324.466949 456.004578,323.874634 z"
          />

          <path
            fill="transparent"
            opacity="1.000000"
            stroke="none"
            d="M450.000122,373.575012 

            C464.805298,373.770020 479.114594,373.814941 493.414246,374.209167 

            C504.260681,374.508179 509.238007,382.603424 504.743286,392.647644 

            C503.932587,394.459259 501.510956,396.559662 499.657196,396.742401 

            C474.601746,399.212219 449.547363,398.870087 424.177856,396.313507 

            C424.177856,388.721436 424.177856,381.503937 424.177856,373.575165 

            C432.662781,373.575165 441.081451,373.575165 450.000122,373.575012 z"
          />

          <path
            fill="transparent"
            opacity="1.000000"
            stroke="none"
            d="M637.000366,324.007874 

            C647.803650,324.383575 658.113770,324.632690 668.408447,325.175323 

            C676.547974,325.604401 678.792603,328.175690 678.980042,336.445892 

            C679.292297,350.228302 678.177490,352.328094 664.670532,352.580994 

            C643.588928,352.975708 622.483154,352.201813 601.392883,351.699097 

            C600.048157,351.667084 597.659302,349.761749 597.606140,348.640198 

            C597.261230,341.362976 597.429138,334.061401 597.429138,325.687225 

            C610.731445,325.115479 623.615967,324.561676 637.000366,324.007874 z"
          />

          <path
            fill="transparent"
            opacity="1.000000"
            stroke="none"
            d="M849.801270,328.330872 

            C850.688171,332.864014 851.840820,337.069702 851.893250,341.289001 

            C852.079163,356.260925 851.956970,371.238129 851.814209,386.212036 

            C851.742493,393.735413 849.156982,396.717987 841.645630,396.806946 

            C821.369995,397.047058 801.088318,397.046051 780.812256,396.834595 

            C773.441284,396.757721 770.915283,393.906281 770.877075,386.653168 

            C770.786804,369.529327 770.788635,352.404388 770.874756,335.280548 

            C770.909302,328.421478 773.214783,325.480713 779.971497,325.376160 

            C800.576721,325.057251 821.190247,325.112152 841.797791,325.307861 

            C844.394287,325.332520 846.974548,327.067230 849.801270,328.330872 z"
          />

          <path
            fill="transparent"
            opacity="1.000000"
            stroke="none"
            d="M1006.073914,324.945007 

            C1006.868286,324.990112 1007.201477,324.995636 1007.534607,325.006927 

            C1019.501953,325.412262 1021.535461,327.333618 1021.539185,339.157837 

            C1021.544250,355.307037 1021.519409,371.460938 1021.121826,387.603333 

            C1020.954712,394.390686 1018.711243,396.642578 1011.847961,396.727722 

            C991.220154,396.983673 970.585266,396.979095 949.957214,396.733856 

            C943.111023,396.652496 940.758667,394.456146 940.617737,387.641724 

            C940.253052,370.000153 940.214905,352.343109 940.521973,334.700531 

            C940.645813,327.587921 943.106567,325.416046 950.702820,325.270111 

            C969.001709,324.918610 987.308899,325.000854 1006.073914,324.945007 z"
          />

          <path
            fill="transparent"
            opacity="1.000000"
            stroke="none"
            d="M1251.693848,298.354858 

            C1257.824463,297.533417 1262.319580,299.617188 1264.949951,304.751038 

            C1267.250854,309.241821 1266.885498,313.802216 1263.613281,317.839478 

            C1260.313354,321.910950 1255.864136,323.016388 1251.015137,321.757721 

            C1246.008789,320.458252 1243.198730,316.702850 1242.399536,311.754761 

            C1241.610962,306.872162 1243.773682,302.998535 1247.729614,300.176605 

            C1248.791748,299.418976 1250.110962,299.021698 1251.693848,298.354858 

            M1259.417725,313.411377 

            C1259.294800,312.157654 1258.700806,310.705566 1259.130615,309.684601 

            C1260.979248,305.294189 1259.968750,302.943573 1255.347778,302.343567 

            C1252.969727,302.034790 1250.518433,302.289337 1248.224854,302.289337 

            C1248.224854,307.910583 1248.224854,312.940674 1248.224854,317.970734 

            C1248.768188,318.099152 1249.311523,318.227570 1249.854858,318.355988 

            C1250.407471,316.350220 1250.959961,314.344421 1251.408691,312.715454 

            C1257.898804,308.900330 1255.711304,317.633423 1259.726562,318.490631 

            C1259.726562,316.688110 1259.726562,315.423676 1259.417725,313.411377 z"
          />

          <path
            className={classes.webrootText}
            opacity="1.000000"
            stroke="none"
            d="M1259.572144,313.785309 

            C1259.726562,315.423676 1259.726562,316.688110 1259.726562,318.490631 

            C1255.711304,317.633423 1257.898804,308.900330 1251.408691,312.715454 

            C1250.959961,314.344421 1250.407471,316.350220 1249.854858,318.355988 

            C1249.311523,318.227570 1248.768188,318.099152 1248.224854,317.970734 

            C1248.224854,312.940674 1248.224854,307.910583 1248.224854,302.289337 

            C1250.518433,302.289337 1252.969727,302.034790 1255.347778,302.343567 

            C1259.968750,302.943573 1260.979248,305.294189 1259.130615,309.684601 

            C1258.700806,310.705566 1259.294800,312.157654 1259.572144,313.785309 

            M1250.892212,307.531830 

            C1252.160522,308.214874 1253.394653,309.304565 1254.710938,309.414642 

            C1255.400269,309.472290 1256.605591,307.900757 1256.849731,306.889282 

            C1256.978271,306.356903 1255.418335,304.745361 1254.834106,304.846954 

            C1253.452881,305.087128 1252.199341,306.060791 1250.892212,307.531830 z"
          />

          <path
            fill="transparent"
            opacity="1.000000"
            stroke="none"
            d="M1250.893188,307.134827 

            C1252.199341,306.060791 1253.452881,305.087128 1254.834106,304.846954 

            C1255.418335,304.745361 1256.978271,306.356903 1256.849731,306.889282 

            C1256.605591,307.900757 1255.400269,309.472290 1254.710938,309.414642 

            C1253.394653,309.304565 1252.160522,308.214874 1250.893188,307.134827 z"
          />
        </svg>
      );
      break;
    case "umbrella/poll":
      svg = (
        <svg
          width={props.width}
          height={props.height}
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 213.2 24.7"
        >
          <path
            className={classes.umbrella}
            d="M30.9 18.1c-.1 0-.7-.4-1.6-.4-1.2 0-2.1.9-2.1 2s.8 2 2.1 2c.9 0 1.5-.4 1.6-.4v2c-.2.1-.9.3-1.7.3-2.1 0-4-1.5-4-3.9 0-2.2 1.7-3.9 4-3.9.9 0 1.5.2 1.7.3v2zm-19.7 0c-.1 0-.7-.4-1.6-.4-1.2 0-2.1.9-2.1 2s.8 2 2.1 2c.9 0 1.5-.4 1.6-.4v2c-.2.1-.9.3-1.7.3-2.1 0-4-1.5-4-3.9 0-2.2 1.7-3.9 4-3.9.9 0 1.5.2 1.7.3v2zm29.7 1.6c0 2.1-1.7 3.9-4 3.9s-4-1.7-4-3.9c0-2.1 1.7-3.9 4-3.9 2.3.1 4 1.8 4 3.9m-4-1.9c-1.1 0-2 .9-2 2s.8 2 2 2c1.1 0 2-.9 2-2s-.9-2-2-2m-14-.1s-.8-.2-1.5-.2c-.8 0-1.2.3-1.2.6 0 .5.6.6.9.7l.5.2c1.2.4 1.8 1.2 1.8 2.1 0 1.9-1.7 2.5-3.1 2.5-1 0-1.9-.2-2-.2v-1.7c.2 0 1 .3 1.8.3.9 0 1.4-.3 1.4-.7 0-.4-.4-.6-.8-.7-.1 0-.3-.1-.4-.1-1.1-.3-1.9-1-1.9-2.2 0-1.4 1-2.3 2.8-2.3.9 0 1.8.2 1.8.2l-.1 1.5zM3.5 7.9c0-.5-.5-.9-1-.9s-.9.4-.9.9v2c0 .5.4.9.9.9s.9-.4.9-.9l.1-2zm5.1-2.6c0-.5-.4-.9-.9-.9s-.9.4-.9.9v4.6c0 .5.4.9.9.9s.9-.4.9-.9V5.3zm5.2-3.5c0-.5-.4-.9-.9-.9s-.9.4-.9.9v10c0 .5.4.9.9.9s.9-.4.9-.9v-10zm5.1 3.5c0-.5-.4-.9-.9-.9s-.9.4-.9.9v4.6c0 .5.4.9.9.9s.9-.4.9-.9V5.3zm5.2 2.6c0-.5-.4-.9-.9-.9s-.9.4-.9.9v2c0 .5.4.9.9.9s.9-.4.9-.9v-2zm5.2-2.6c0-.5-.4-.9-.9-.9s-.9.4-.9.9v4.6c0 .5.4.9.9.9s.9-.4.9-.9V5.3zm5.1-3.5c0-.5-.4-.9-.9-.9s-.9.4-.9.9v10c0 .5.4.9.9.9s.9-.4.9-.9v-10zm5.2 3.5c0-.5-.4-.9-.9-.9s-.9.4-.9.9v4.6c0 .5.4.9.9.9s.9-.4.9-.9V5.3zm5.1 2.6c0-.5-.4-.9-.9-.9s-.9.4-.9.9v2c0 .5.4.9.9.9s.9-.4.9-.9v-2zM13.8 16h1.9v7.5h-1.9zM70 17.6h1.3c-.4 3.3-3 6-7 6-4.6 0-7.7-3.4-7.7-8.8 0-5.9 3.4-9.1 7.7-9.1 3.7 0 6.5 2.1 7 5.5H70C69.4 8.5 67.3 7 64.3 7 60.7 7 58 9.8 58 14.9c0 4.8 2.7 7.6 6.4 7.6 3 0 5.2-1.8 5.6-4.9zM73.9 8V6.2h1.5V8h-1.5zm.2 15.3V11h1.3v12.4h-1.3v-.1zm8.2-6c-2.5-.4-4-1.5-4-3.4s1.5-3.3 4.5-3.3c2.6 0 4.5 1.3 4.8 3.4h-1.3c-.2-1.4-1.6-2.4-3.5-2.4-2.2 0-3.1 1-3.1 2.1 0 1.4.8 2 3.4 2.5 3.2.6 4.6 1.6 4.6 3.7 0 2-1.8 3.7-4.9 3.7-2.9 0-4.7-1.5-5-3.6h1.3c.2 1.6 1.5 2.6 3.7 2.6 2.3 0 3.5-1.2 3.5-2.6 0-1.5-1.2-2.2-4-2.7zm18 2.4c-.4 2.3-2.4 4-5.1 4-3.1 0-5.5-2.2-5.5-6.4 0-4.4 2.4-6.6 5.5-6.6 2.6 0 4.6 1.5 5 3.8h-1.4c-.3-1.6-1.7-2.7-3.6-2.7-2.4 0-4.2 1.8-4.2 5.6 0 3.6 1.9 5.3 4.2 5.3 1.9 0 3.4-1.2 3.7-2.9h1.4v-.1zm7.7-9.1c3.3 0 5.7 2.2 5.7 6.5s-2.4 6.5-5.7 6.5c-3.2 0-5.7-2.3-5.7-6.5 0-4.3 2.4-6.5 5.7-6.5zm0 12c2.5 0 4.4-1.9 4.4-5.5 0-3.7-1.8-5.5-4.4-5.5-2.5 0-4.4 1.9-4.4 5.5s1.9 5.5 4.4 5.5zm15.4-4.9V6.2h1.3v11.6c0 2.8 2.2 4.8 5.2 4.8s5.2-2 5.2-4.8V6.2h1.3v11.5c0 3.4-2.5 6-6.5 6-4.1 0-6.5-2.7-6.5-6zm16.4 5.6V11h1.1l.1 1.9c.8-1.6 2.4-2.3 3.8-2.3 1.9 0 3.2.9 3.7 2.4.8-1.7 2.5-2.4 4-2.4 2.5 0 4 1.5 4 4.2v8.5h-1.3v-8.4c0-2.2-1.1-3.2-3-3.2-2 0-3.5 1.8-3.5 4v7.7h-1.3V15c0-2.2-1-3.2-2.9-3.2-2 0-3.5 1.7-3.5 3.9v7.7h-1.2v-.1zm19.9 0V6.2h1.3v7.1c.8-1.5 2.3-2.7 4.4-2.7 3.1 0 5.2 2.1 5.2 6.4 0 4.4-2.3 6.7-5.3 6.7-2 0-3.5-1.1-4.3-2.6l-.2 2.3h-1.1v-.1zm5.4-11.6c-2.1 0-4.2 1.5-4.2 5.4 0 3.6 1.7 5.4 4.2 5.4 2.4 0 4.2-1.8 4.2-5.6-.1-3.6-1.8-5.2-4.2-5.2zm8.1 11.6V11h1l.2 2.4c.7-1.9 1.9-2.7 3.5-2.7.5 0 1 .1 1.3.2V12c-.4-.1-.9-.2-1.4-.2-1.8 0-3.4 1.8-3.4 4.7v6.8h-1.2zm17.8-3.4c-.6 2.3-2.5 3.7-5.1 3.7-3.4 0-5.9-2.3-5.9-6.5s2.4-6.5 5.6-6.5c3.2 0 5.6 2.1 5.6 6.8h-9.9c.1 3.5 2.1 5.1 4.6 5.1 1.9 0 3.3-1 3.8-2.6h1.3zm-9.7-3.5h8.6c-.2-3.2-2-4.7-4.3-4.7-2.2-.1-4.1 1.6-4.3 4.7zm13.9 6.9h-1.3V6.2h1.3v17.1zm4.6 0h-1.3V6.2h1.3v17.1zm3-9.1c.2-2.1 2.1-3.6 4.8-3.6 2.8 0 4.6 1.5 4.6 4.1v8.7h-1l-.2-2c-.8 1.3-2.2 2.4-4.4 2.4-2.4 0-4.1-1.3-4.1-3.5 0-2.1 1.3-3.4 4.8-4l3.7-.6v-1.1c0-1.8-1.3-2.9-3.4-2.9-2 0-3.2 1-3.4 2.5h-1.4zm8.1 4.7v-2.3l-3.3.6c-2.9.5-3.8 1.4-3.8 2.9 0 1.7 1.3 2.5 3.1 2.5 2 0 4-1.5 4-3.7z"
          />
        </svg>
      );
      break;
    default:
      svg = <span />;
      break;
  }
  return svg;
}
